









import { Component, Vue } from "vue-property-decorator";
import ActivityViewer from "@/containers/ActivityViewer.vue";
import Activities from "@/sample/activities.json";

@Component({
  components: {
    ActivityViewer
  }
})
export default class Home extends Vue {
  activity = Activities;

  get page(): number {
    return Number(this.$route.params.page) || 1;
  }

  get count(): number {
    return 1000;
  }
}
